import { BrowserRouter } from 'react-router-dom';
import './App.css';
import Navrouting from './component/Navrouting';

function App() {
  return (
    <div className="App">
    <BrowserRouter>
     <Navrouting/>
    </BrowserRouter>
    </div>
  );
}

export default App;
